"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppleProxyVoidResponseSchema = exports.LanguageCodeSchema = exports.LanguageSchema = exports.AppleProxySelectorSchema = exports.AppleProxyCustomReportPaginationSchema = exports.AppleProxyPaginationSchema = exports.AppleProxySortingSchema = exports.AppleProxySortOrderSchema = exports.AppleProxyApiErrorResponseSchema = exports.AppleProxyErrorResponseBodySchema = exports.AppleProxyPageDetailSchema = exports.AppleProxyStatusSchema = exports.AppleProxyServingStatusSchema = exports.AppleProxyDeviceClassSchema = exports.AppleProxyDisplayStatusSchema = exports.AppleProxyModificationTimeSchema = exports.AppleProxyDateTimeSchema = exports.AppleProxyAdamRefParamsSchema = exports.AppleProxyRefParamsSchema = exports.AppleProxyCustomReportRefParamsSchema = exports.AppleProxyOrgHeaderSchema = exports.AppleProxyInternalErrorSchema = exports.AppleProxyAdamRefSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const headers_1 = require("../../../headers");
const ruby_1 = require("../../../ruby");
const utils_1 = require("../../../utils");
exports.AppleProxyAdamRefSchema = typebox_1.Type.Integer({
    title: "ADAM ID",
    description: "Your unique App Store app identifier.",
});
exports.AppleProxyInternalErrorSchema = typebox_1.Type.Object({
    message: typebox_1.Type.String(),
    error: typebox_1.Type.Unknown(),
});
exports.AppleProxyOrgHeaderSchema = typebox_1.Type.Object({
    [headers_1.APPLE_PROXY_ORG_ID_HEADER]: typebox_1.Type.String(),
}, {
    title: "Organisation ID Header",
    description: "Contains the orgId value for the organization that owns the campaign in Apple ASA.",
});
exports.AppleProxyCustomReportRefParamsSchema = (0, core_1.StrictObject)({
    id: typebox_1.Type.Integer(),
});
exports.AppleProxyRefParamsSchema = (0, core_1.StrictObject)({
    id: ruby_1.AppleProxyRefSchema,
}, {
    title: "ID Params",
    description: "Params object requiring an identifier.",
});
exports.AppleProxyAdamRefParamsSchema = (0, core_1.StrictObject)({
    adamId: exports.AppleProxyAdamRefSchema,
});
exports.AppleProxyDateTimeSchema = typebox_1.Type.String({
// TODO We could use a regex here for validation
});
exports.AppleProxyModificationTimeSchema = (0, utils_1.extendStringType)(exports.AppleProxyDateTimeSchema, {
    title: "Modification Time",
    description: "The date and time of the most recent modification of the object.",
});
exports.AppleProxyDisplayStatusSchema = (0, core_1.StringUnion)([
    "DELETED",
    "ON_HOLD",
    "PAUSED",
    "RUNNING",
]);
exports.AppleProxyDeviceClassSchema = (0, core_1.StringUnion)(["IPAD", "IPHONE"], {
    title: "Device Class",
    description: "Defines the type of device.",
});
exports.AppleProxyServingStatusSchema = (0, core_1.StringUnion)([
    "NOT_RUNNING",
    "RUNNING",
]);
exports.AppleProxyStatusSchema = (0, core_1.StringUnion)(["ENABLED", "PAUSED"]);
exports.AppleProxyPageDetailSchema = (0, core_1.StrictObject)({
    itemsPerPage: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    startIndex: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    totalResults: typebox_1.Type.Optional(typebox_1.Type.Integer()),
});
const AppleProxyErrorResponseItemSchema = (0, core_1.StrictObject)({
    field: typebox_1.Type.String(),
    message: typebox_1.Type.String(),
    messageCode: typebox_1.Type.String(),
});
exports.AppleProxyErrorResponseBodySchema = (0, core_1.StrictObject)({
    errors: (0, core_1.OptionalNullable)(typebox_1.Type.Array(AppleProxyErrorResponseItemSchema)),
});
exports.AppleProxyApiErrorResponseSchema = (0, core_1.StrictObject)({
    error: typebox_1.Type.Optional(exports.AppleProxyErrorResponseBodySchema),
});
const AppleProxyOperatorSchema = (0, core_1.StringUnion)([
    "BETWEEN",
    "CONTAINS",
    "CONTAINS_ALL",
    "CONTAINS_ANY",
    "ENDSWITH",
    "EQUALS",
    "GREATER_THAN",
    "IN",
    "LESS_THAN",
    "STARTSWITH",
]);
const AppleProxyFieldSchema = typebox_1.Type.String({
    title: "Field",
    maxLength: 256,
});
const AppleProxyFieldValueSchema = typebox_1.Type.Union([
    typebox_1.Type.String({ maxLength: 256 }),
    typebox_1.Type.Number(),
]);
const AppleProxyConditionSchema = (0, core_1.StrictObject)({
    field: typebox_1.Type.Optional(AppleProxyFieldSchema),
    operator: typebox_1.Type.Optional(AppleProxyOperatorSchema),
    values: typebox_1.Type.Optional(typebox_1.Type.Array(AppleProxyFieldValueSchema)),
});
exports.AppleProxySortOrderSchema = (0, core_1.StringUnion)([
    "ASCENDING",
    "DESCENDING",
]);
exports.AppleProxySortingSchema = (0, core_1.StrictObject)({
    field: typebox_1.Type.Optional(AppleProxyFieldSchema),
    sortOrder: typebox_1.Type.Optional(exports.AppleProxySortOrderSchema),
});
const AppleProxyLimitSchema = typebox_1.Type.Integer({
    title: "Limit",
    description: "The number of items to return per request. The maximum is 1000 for most objects.",
    minimum: 1,
});
const AppleProxyOffsetSchema = typebox_1.Type.Integer({
    title: "Offset",
    description: "The offset pagination that limits the number of returned records. The start of each page is offset by the specified number.",
    minimum: 0,
});
exports.AppleProxyPaginationSchema = (0, core_1.StrictObject)({
    limit: (0, core_1.OptionalNullable)(AppleProxyLimitSchema),
    offset: (0, core_1.OptionalNullable)(AppleProxyOffsetSchema),
});
exports.AppleProxyCustomReportPaginationSchema = (0, core_1.StrictObject)({
    limit: (0, core_1.OptionalNullable)(AppleProxyLimitSchema),
    offset: (0, core_1.OptionalNullable)(AppleProxyOffsetSchema),
    field: (0, core_1.OptionalNullable)(AppleProxyFieldSchema),
    sortOrder: (0, core_1.OptionalNullable)(exports.AppleProxySortOrderSchema),
});
exports.AppleProxySelectorSchema = (0, core_1.StrictObject)({
    conditions: typebox_1.Type.Optional(typebox_1.Type.Array(AppleProxyConditionSchema)),
    fields: typebox_1.Type.Optional(typebox_1.Type.Array(AppleProxyFieldSchema)),
    orderBy: typebox_1.Type.Optional(typebox_1.Type.Array(exports.AppleProxySortingSchema)),
    pagination: typebox_1.Type.Optional(exports.AppleProxyPaginationSchema),
});
exports.LanguageSchema = typebox_1.Type.String();
exports.LanguageCodeSchema = typebox_1.Type.String();
exports.AppleProxyVoidResponseSchema = typebox_1.Type.Object({
    data: (0, core_1.OptionalNullable)(core_1.EmptyResponseSchema),
    error: (0, core_1.OptionalNullable)(exports.AppleProxyErrorResponseBodySchema),
    pagination: (0, core_1.OptionalNullable)(exports.AppleProxyPageDetailSchema),
});
